module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesUrban@2x.5e1d484.jpg";